import { ReactComponent as IconBuyingGroups } from 'assets/images/svg/buyingGroup.svg';
import { ReactComponent as IconFilter } from 'assets/images/svg/filter.svg';
import React from 'react';

import DatePicker from 'components/common/datePicker/DatePicker';
import DropdownMenu from 'components/common/menu/DropdownMenu';
import { mockedAccountLists, mockedBuyingGroups } from 'components/views/mockedData';
import './TopBar.scss';

const TopBar = (): React.ReactElement => {
  // Calculate end date as today and start date as 5 weeks ago for the demo purposes
  const today = new Date();
  const sevenWeeksAgo = new Date(today);
  sevenWeeksAgo.setDate(today.getDate() - 7 * 5); // 5 weeks = 35 days

  const [dateRange, setDateRange] = React.useState<{
    startDate: Date | null;
    endDate: Date | null;
  }>({
    startDate: sevenWeeksAgo,
    endDate: today,
  });

  return (
    <div className='top-bar'>
      <div className='dropdown-container'>
        <div className='icon-label'>
          <IconBuyingGroups className='list-icon' />
        </div>
        <DropdownMenu
          options={mockedBuyingGroups}
          className='top-bar__dropdown'
          defaultValue={mockedBuyingGroups[0]}
        />
      </div>
      <div className='dropdown-container'>
        <div className='icon-label'>
          <IconFilter className='list-icon' />
        </div>
        <DropdownMenu
          options={mockedAccountLists}
          className='top-bar__dropdown'
          defaultValue={mockedAccountLists[0]}
        />
      </div>
      <div className='top-bar__date-picker'>
        <DatePicker
          className='top-bar__date-picker-input'
          startDate={dateRange.startDate as Date}
          endDate={dateRange.endDate as Date}
          onChange={(dates: { startDate: Date | null; endDate: Date | null }) =>
            setDateRange(dates)
          }
        />
      </div>
    </div>
  );
};

export default TopBar;
